<template>
  <div class="inputSearch">
     <input type="text" class="inputSear" :id="id" :name1="expName1" :name2="expName2" :name3="expName3" v-model="inputText" ref="ipt"
      :placeholder="setPlaceholder"
      :style="{width:setWidth,height:height,}"
      @focus="focusInput"
      @click="clkDownText"
      @keydown="keydown($event)"
      @input="getInputVal(inputText)"
      @blur="blurInput"
      />
      <div class="dataBox" :style="{width:setWidth}" id='hotcity' v-if="isShow==1 || isShow==2 || isShow==3 ? true : false ">
        <!-- 热门数据 start-->
         <label v-if="isShow==1 ? true : false ">
          <h3>Hot cities</h3>
          <ul>
            <li v-for="(item,index) in expHotCity" @click="getText(item)" :key="index" 
            :class="{isActive:index==isIndex}" :id="item.CityKey" :name1="item.NameEn" :name2="item.NameCh" :name3="item.Province_NameEn"
            @mouseover="clearKeydown(index)">
                {{item.NameEn}}, {{item.Province_NameEn}}
            </li>
          </ul>
         </label>
         <!-- 热门数据 end -->
         <!-- 模糊搜索 start -->
         <ul v-if="isShow==2 ? true : false" >
           <li v-for="(item,index) in cityItems" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" :id="item.CityKey" :name1="item.CityNameEn" :name2="item.CityNameCh" :name3="item.Province_NameEn"
            @mouseover="clearKeydown(index)">{{item.CityNameEn}}, {{item.Province_NameEn}}</li>
         </ul>
         <ul v-if="isShow==3 ? true : false">
           <li class="sepTipsMsg">No result</li>
         </ul>
        <!-- 模糊搜索 end -->
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import bus from '../../../ask/eventBus';
import { post, fetch, Del, put } from "../../../ask/axios";
  export default {
    props: {
       setPlaceholder: { type: String }, //输入框默认值
       setWidth: { type: String }, //宽度
       height: { type: String }, //高度
      // marginLeft: { type: String }, //高度
      // myClass: {type: String},
      // name:{type:String},
    },
    data () {
      return {
        api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
        isIndex:-1,
        id:"",
        expName1:'',
        expName2:'',
        expName3:'',

        inputText:'',
        expStartText:'',
        expStartTextCh:'',
        expPro:'',
        expStartKey:'',

        expHotCity:[], //热门数据
        cityItems:[], //搜索数据

        isShow:0, //是否显示热门数据 1:热门数据显示，2：搜索数据显示
        focusState: false, //点击其他区域就关闭下拉框]         
      }
    },
    created() {
      this.hotFunction(); //热门数据接口
    },
    mounted(){
      //console.log('widthde '  +  this.setPlaceholder)
        //点击其他区域关闭自定义div
      document.addEventListener('click',(e) => {
          if(this.isShow==1 || this.isShow==2 || this.isShow==3 ){
            var sp = document.getElementById("hotcity");
            if(sp && !sp.contains(e.target)) {
              this.isShow=0
            }
          }
        })
    },

    computed: { //计算属性函数
     },

    methods:{
      //---------基础设置方法----------//
      //点击input自动选中里面的值
      focusInput:function(e) {
        this.$refs.ipt.select(); // or e.currentTarget.select();
      },
      blurInput(){
        if(!this.expStartKey){
           this.inputText=''
        }
      },

      //键盘方法
      keydown(e){
         let showList=0
         if(this.isShow==1){
              showList=this.expHotCity.length //热门数据
          }else if(this.isShow==2){
             showList=this.cityItems.length //搜索数据
          }

        if (e.keyCode == 40) {//下键
          this.isIndex++;
          if (this.isIndex > showList-1) {
             this.isIndex = 0;
          }
        } else if (e.keyCode == 38) {//上
          this.isIndex--;
          if (this.isIndex < 0) {
            this.isIndex = showList - 1;
          }
        } else if (e.keyCode == 13) {//回车
         let text = document.querySelector('.isActive');
        if(text){
           this.inputText = text.innerText;
           this.expStartKey = text.getAttribute("id")
           this.expStartText= text.getAttribute('name1')
           this.expStartTextCh= text.getAttribute('name2')
           this.expPro = text.getAttribute('name3')
          
           this.isShow=0
           this.isIndex = -1;
         }  

         let expCityValue = {
            expCityEn: this.expStartText,
            expCityCh: this.expStartTextCh,
            expNamePro: this.expPro,
            citykey: this.expStartKey
          };
          this.$emit('byCityValue',expCityValue)        
        }
      },
       //鼠标移入时清除键盘事件
      clearKeydown(index){
        this.isIndex = index;
      },

    //----------热门数据------------//
     //点击input 出现下拉内容
      clkDownText(){
        this.isShow=1
      },
      //点击热门和搜索数据选中
      getText(item){
        if(this.isShow==1){
        this.expStartText=item.NameEn
        this.expStartTextCh=item.NameCh
        this.expPro=item.Province_NameEn
        this.expStartKey=item.CityKey
        }else if(this.isShow==2){
          this.expStartText=item.CityNameEn
          this.expStartTextCh=item.CityNameCh
          this.expPro=item.Province_NameEn
          this.expStartKey=item.CityKey
        }
        this.inputText= this.expStartText+', '+this.expPro //text赋值
        this.isShow=0 //关闭下拉框
      // console.log('this.expStartKey222 ' +  JSON.stringify(this.expStartKey))
       //传值到父组件
       let expCityValue = {
            expCityEn: this.expStartText,
            expCityCh: this.expStartTextCh,
            expNamePro: this.expPro,
            citykey: this.expStartKey
          };
         this.$emit('byCityValue',expCityValue)
      },
       //热门数据接口
      hotFunction(){
        let that = this;
        that.api.param={
          "mainCode":'KDHotCity',
        }
        // this.api.url=this.$api01+"/api/InfoCustomer/Attribute/QueryHotCity"
        this.api.url=this.$api04+"/Basics/api/Attribute/QueryHotCity"
        fetch(this.api.url,this.api.param).then(function(res) {
           // console.log('ddd ' +  JSON.stringify(res))
           if(res.Results){
              that.expHotCity = res.Results              
           }
        });
      },

         //----------搜索城市数据------------//
         //货物input输入框输入值
         getInputVal(val){
          this.searchCity(); //搜索数据接口
          if(!this.inputText){
            this.isShow=1
          }
          this.expStartKey=''
          //console.log('sdd   '+this.expStartKey)
         //传值到父组件
       let expCityValue = {
            expCityEn: this.expStartText,
            expCityCh: this.expStartTextCh,
            expNamePro: this.expPro,
            citykey: this.expStartKey
          };
         this.$emit('byCityValue',expCityValue)
          
         },
      searchCity(){
        let that = this;
        that.api.param={
          // "CityName":this.inputText,
          "CityName":this.inputText,
          "Type":'Ch', //Ch:查中国城市数据  En：查海外城市数据
          "Take":50,
        }
        // this.api.url=this.$api02+"/api/EbayCustomer/City/GetStartCityQuery"
        this.api.url=this.$api04 + "/Basics/api/SysRegion/GetStartCityQuery"
        post(this.api.url,this.api.param).then(function(res){
          if(res.Results){
              if(res.Results.length > 0){               
                  that.cityItems = res.Results                  
                  that.isShow=2
              }else{
                that.isShow=3
              }
          }          
        });
      },
    }

  }
</script>
<style lang="css" scoped>
.inputSearch{position: relative;}
.inputSear{border:1px solid #ddd;border-radius:5px;padding:0 5px;}

.dataBox{background:#fff;border:1px solid #eee;border-radius:5px;position:absolute;top:31px;left:0px;z-index:66;padding:5px;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);-webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);}
  .dataBox h3{height:30px;line-height:30px;padding:0 5px;font-size:13px;}
  .dataBox ul li{cursor: pointer;padding:0 10px;margin:0 -5px;color:#888;}
  .dataBox ul li:hover{background:#f5f5f5;}
  .isActive{background:#f5f5f5;}

  .sepTipsMsg{color:#999;text-align:center;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/expStartCity.vue